import { defineStore } from 'pinia';
import { ref } from 'vue';
import { FormPartAData } from '../models/form-part-a-data';

export const useFormPartADataStore = defineStore('FormPartADataStore', () => {
  const formPartAData = ref({} as FormPartAData);

  function setFormPartAData(i: FormPartAData) {
    formPartAData.value = i;
  }

  function clearFormPartAData() {
    formPartAData.value = {} as FormPartAData;
  }

  return {
    formPartAData,
    setFormPartAData,
    clearFormPartAData,
  };
});
